import React from 'react';
import FAQItem from './FAQItem';
import type { FAQCategory as FAQCategoryType } from '@/types/faq';

interface FAQCategoryProps {
  category: FAQCategoryType;
}

const FAQCategory: React.FC<FAQCategoryProps> = ({ category }) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-4" id={category.id}>
        <div className="w-2.5 h-11 bg-orange-500 rounded-md"></div>
        <h2
          className="text-white text-3xl font-normal tracking-tight"
          dangerouslySetInnerHTML={{ __html: category.title }}
        />
      </div>
      
      <div className="flex flex-col gap-4">
        {category.questions.map((question) => (
          <FAQItem key={question.id} question={question} />
        ))}
      </div>
    </div>
  );
};

export default FAQCategory;